﻿import React from 'react';

const PossessionsTableHeader = ({content, selected, heading}) => {

    return (
        <thead className="possessions__table__header">
            <tr>
                <th className="possessions__table__header__heading">{heading}</th>

                {content.levels.map(level => 
                    <th key={level.label}
                        className={`possessions__table__header__level ${selected === level.label ? "selected" : ""}`}>
                        {selected === level.label && <span>Vald</span>}
                        {level.label}
                    </th>   
                )}
            </tr>
        </thead>    
     )
};

export default PossessionsTableHeader;

